var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppDateTimePicker',{attrs:{"type":"daterange","value":_vm.value,"picker-options":_vm.pickerOptions,"unlink-panels":""},on:{"input":_vm.valueChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }